import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useMarket } from '../contexts/MarketContext';
import { useAddToCart } from '../hooks/useAddToCart';
interface CTAButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  fullWidth?: boolean;
}

/**
 * Purchase CTA.
 *
 * This is a PLAIN anchor on purpose: iOS Safari can swallow taps on an
 * animated/transformed JS-driven element, which left users on a blank page
 * instead of the cart. The float/hover motion is now pure CSS (`cta-float`),
 * so nothing intercepts the tap and the browser performs a normal navigation
 * to the Shopify cart permalink even if the pixel or any script fails.
 */
export function CTAButton({
  children,
  size = 'lg',
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const {
    cartHref
  } = useMarket();
  const onAddToCart = useAddToCart();
  const sizes = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <a href={cartHref} onClick={onAddToCart} className={['cta-float group relative inline-flex items-center justify-center gap-2 rounded-2xl bg-brandgreen font-display font-extrabold uppercase tracking-wide text-white shadow-cta', 'transition-colors duration-300 hover:bg-[#26794d]', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy', sizes, fullWidth ? 'w-full' : '', className].join(' ')} data-id="element-60" data-mp="199eksh3gyghs">
      <span data-id="element-61" data-mp="1w81ceezd0994">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-300 group-hover:translate-x-1 motion-reduce:transition-none" aria-hidden="true" data-id="element-62" data-mp="1w79h759ocdjd" />
    </a>;
}